import React from "react";
import { useChatAttachments } from "./hooks";
import { useChatPanelData } from "./hooks";
import { EmptyStateView, ConversationView, AgentView } from "./components";

const ChatPanel = ({ selectedConversationId, selectedAgentId }) => {
  const { messages } = useChatPanelData(selectedConversationId, selectedAgentId);
  const {
    attachments,
    handleFilesSelected,
    handleAttachmentRemove,
    handleAddMenuChange,
    handleModeMenuChange,
  } = useChatAttachments();

  const showEmptyState = !selectedConversationId && !selectedAgentId;
  const showConversationView = selectedConversationId && messages.length > 0;
  const showAgentView = selectedAgentId || (selectedConversationId && messages.length === 0);

  if (showEmptyState) {
    return (
      <EmptyStateView
        attachments={attachments}
        onFilesSelected={handleFilesSelected}
        onAttachmentRemove={handleAttachmentRemove}
        onAddMenuChange={handleAddMenuChange}
        onModeMenuChange={handleModeMenuChange}
      />
    );
  }

  if (showConversationView) {
    return (
      <ConversationView
        messages={messages}
        attachments={attachments}
        onFilesSelected={handleFilesSelected}
        onAttachmentRemove={handleAttachmentRemove}
        onAddMenuChange={handleAddMenuChange}
        onModeMenuChange={handleModeMenuChange}
      />
    );
  }

  if (showAgentView) {
    return (
      <AgentView
        selectedAgentId={selectedAgentId}
        attachments={attachments}
        onFilesSelected={handleFilesSelected}
        onAttachmentRemove={handleAttachmentRemove}
        onAddMenuChange={handleAddMenuChange}
        onModeMenuChange={handleModeMenuChange}
      />
    );
  }

  return null;
};

export default ChatPanel;
